import React from 'react'
import { Helmet } from 'react-helmet'
import {
  createBlogPostingSchema,
  createBlogListSchema,
  createBlogBreadcrumbSchema
} from '@pool/config/seo/schemas'
import { posts } from '@pool/content/blog/posts'

const SITE_URL = 'https://linkpool.com'

export function BlogListSeo() {
  const schema = createBlogListSchema(posts)
  const breadcrumb = createBlogBreadcrumbSchema()

  return (
    <Helmet>
      <title>Blog | LinkPool</title>
      <meta
        name="description"
        content="Latest news and insights from LinkPool about Web3 infrastructure, liquid staking, and onchain finance."
      />
      <meta property="og:title" content="Blog | LinkPool" />
      <meta
        property="og:description"
        content="Latest news and insights from LinkPool about Web3 infrastructure, liquid staking, and onchain finance."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${SITE_URL}/blog`} />
      <link rel="canonical" href={`${SITE_URL}/blog`} />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
    </Helmet>
  )
}

export function BlogPostSeo({ frontmatter }) {
  const { title, description, heroImage, date, author, slug } = frontmatter
  const schema = createBlogPostingSchema(frontmatter)
  const breadcrumb = createBlogBreadcrumbSchema(frontmatter)

  return (
    <Helmet>
      <title>{title} | LinkPool</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={`${title} | LinkPool`} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={`${SITE_URL}/blog/${slug}`} />
      <meta
        property="og:image"
        content={
          heroImage?.startsWith('http') ? heroImage : `${SITE_URL}${heroImage}`
        }
      />
      <meta property="article:published_time" content={date} />
      <meta property="article:author" content={author} />
      <link rel="canonical" href={`${SITE_URL}/blog/${slug}`} />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
    </Helmet>
  )
}
